import Vue from "vue";
import App from "./App.vue";
import VBCWebSDK, { init, setMockSdk } from "@/vbc-sdk.js";
import store from "@/store";
import VueRouter from "vue-router";
import router from "./router";
import i18n from "./plugins/i18n";
import WalkMePlugin from './plugins/walkme';
import "@vonage/vwc-icon-button";
import "@vonage/vwc-textfield";
import "@vonage/vwc-textarea";
import "@vonage/vwc-select";
import "@vonage/vwc-list/vwc-list-item";
import "@vonage/vwc-formfield";
import "@vonage/vwc-checkbox";
import "@vonage/vwc-snackbar";
import "@/components/vwc-tooltip";

Vue.config.productionTip = false;
Vue.use(VueRouter);
Vue.use(WalkMePlugin);

(async () => {
  if (process.env.VUE_APP_MOCK_WEBSDK) {
    // style the same as admin-portal wrapping
    document.body.style.background = "#F2F2F2";
    document.body.style.padding = "32px";

    if (!window.Cypress) {
      window.mockSDK = {
        initialize: async () => ({
          token: process.env.VUE_APP_TOKEN,
          accountId: process.env.VUE_APP_ACCOUNT_ID,
        }),
        ready: () => console.log("ready"),
        sendCustomEvent: (event, payload) =>
          Promise.resolve(
            console.log(
              `sendCustomEvent:${event} with payload:${JSON.stringify(payload)}`
            )
          ),
      };
    }
  }
  if (window.mockSDK) {
    setMockSdk(window.mockSDK);
  } else {
    init();
  }
  window.credentials = await VBCWebSDK().initialize();
  window.addEventListener('message', (event) => {
    if (event.data?.event === 'bulkSMSTenDLCfeatureFlag') {
      const enabled = event.data?.payload?.bulkSmsFeatureFlag;
      store.dispatch('smsRegistrations/setBulkSmsFeatureFlag', enabled);
    }
  });
  new Vue({
    store,
    router,
    render: (h) => h(App),
    i18n,
  }).$mount("#app");
})();
